import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
// @ts-ignore
import { MultiSelect } from 'react-native-element-dropdown';
import { FONT_MEDIUM } from '../utils/theme';

const data = [
    { label: 'Item 1', value: '1' },
    { label: 'Item 2', value: '2' },
    { label: 'Item 3', value: '3' },
    { label: 'Item 4', value: '4' },
    { label: 'Item 5', value: '5' },
    { label: 'Item 6', value: '6' },
    { label: 'Item 7', value: '7' },
    { label: 'Item 8', value: '8' },
];

interface ISelectProps {
    onChange: (value: string[]) => void;
    placeholder: string;
    list: { label: string; value: string }[];
    searchPlaceholder: string;
}

export const Select = (props: ISelectProps) => {
    const [selected, setSelected] = useState<any[]>([]);

    const { onChange, placeholder, list, searchPlaceholder } = props;

    return (
        <View style={styles.container}>
            <MultiSelect
                style={styles.dropdown}
                placeholderStyle={styles.placeholderStyle}
                selectedTextStyle={styles.selectedTextStyle}
                inputSearchStyle={styles.inputSearchStyle}
                iconStyle={styles.iconStyle}
                search
                data={list}
                labelField='label'
                valueField='value'
                placeholder={placeholder}
                searchPlaceholder={searchPlaceholder}
                value={selected}
                onChange={(item) => {
                    setSelected(item);
                    onChange(item);
                }}
                renderLeftIcon={() => (
                    /*<AntDesign
              style={styles.icon}
              color="black"
              name="Safety"
              size={20}
            />*/ <></>
                )}
                selectedStyle={styles.selectedStyle}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    container: { padding: 16, width: '100%', fontFamily: FONT_MEDIUM },
    dropdown: {
        height: 50,
        backgroundColor: 'transparent',
        borderBottomColor: 'gray',
        borderBottomWidth: 0.5,
    },
    placeholderStyle: {
        fontSize: 16,
    },
    selectedTextStyle: {
        fontSize: 14,
    },
    iconStyle: {
        width: 20,
        height: 20,
    },
    inputSearchStyle: {
        height: 40,
        fontSize: 16,
    },
    icon: {
        marginRight: 5,
    },
    selectedStyle: {
        borderRadius: 12,
    },
});
